import React from 'react'
import Ide from '../../../components/Ide.js'
import Topbar from '../Htmltopbar'
import '../Lessons.css'



export default function Environment() {

  const handleClick = () => {
    if (document.getElementsByClassName("presentation")[0].style.width = "300px")  {
      document.getElementsByClassName("presentation")[0].style.width = "200px"
      document.getElementsByClassName("links")[0].style.display = "flex"
      document.getElementById("pres").style.left = "940px";
      document.getElementById("pres").style.top = "340px";
    }
    

    if (document.getElementsByClassName("slidecontainer")[0].style.width = "300px") {
      document.getElementsByClassName("presentation")[0].style.width = "200px"
      document.getElementsByClassName("slidecontainer")[0].style.width = "200px"
      document.getElementsByClassName("menu")[0].style.width = "200px"
      document.getElementsByClassName("links")[0].style.display = "flex"
    
    document.getElementById("pres").style.left = "940px";
    document.getElementById("pres").style.top = "340px";

    }
  }

  const mobilehandleClick = () => {
    if (document.getElementsByClassName("presentation")[0].style.width = "300px" ) {
      document.getElementsByClassName("presentation")[0].style.width = "180px"
      document.getElementsByClassName("presentation")[0].style.height = "210px"
      document.getElementsByClassName("links")[0].style.display = "none"
    document.getElementById("pres").style.left = "32px";
    document.getElementById("pres").style.top = "400px";
    }

    if (document.getElementsByClassName("slidecontainer")[0].style.width = "300px") {
      document.getElementsByClassName("presentation")[0].style.width = "180px"
      document.getElementsByClassName("slidecontainer")[0].style.width = "180px"
      document.getElementsByClassName("menu")[0].style.width = "180px"
      document.getElementsByClassName("presentation")[0].style.height = "210px"
      document.getElementsByClassName("links")[0].style.display = "none"
    
    document.getElementById("pres").style.left = "32px";
    document.getElementById("pres").style.top = "400px";
    }

  }


  const altClick = () => {
    if (document.getElementsByClassName("presentation")[0].style.width = "200px" ) {
      document.getElementsByClassName("presentation")[0].style.width = "300px"
      document.getElementsByClassName("slidecontainer")[0].style.width = "300px"
      document.getElementsByClassName("menu")[0].style.width = "300px"
      document.getElementsByClassName("links")[0].style.display = "flex"
    }
    document.getElementById("pres").style.left = "460px";
    document.getElementById("pres").style.top = "135px";
  }

  
  const mobilealtClick = () => {
    if (document.getElementsByClassName("presentation")[0].style.width = "200px" ) {
      document.getElementsByClassName("presentation")[0].style.width = "300px"
      document.getElementsByClassName("presentation")[0].style.height = "330px"
      document.getElementsByClassName("slidecontainer")[0].style.width = "300px"
      document.getElementsByClassName("menu")[0].style.width = "300px"
      document.getElementsByClassName("links")[0].style.display = "none"
    document.getElementById("pres").style.left = "30px";
    document.getElementById("pres").style.top = "200px";
    }

  }

  const mobileClick = () => {
    if (document.getElementsByClassName("slidecontainer")[0].style.width == "50px" ) {
      document.getElementsByClassName("slidecontainer")[0].style.width = "300px"
      document.getElementsByClassName("links")[0].style.display = "none"
      document.getElementsByClassName("menu")[0].style.display = "flex"
      document.getElementsByClassName("menu")[0].style.width = "300px"
      document.getElementById("pres").style.left = "30px";
      document.getElementById("pres").style.top = "200px";
    }
   
    if (document.getElementsByClassName("slidecontainer")[0].style.width == "200px" ) {
      document.getElementsByClassName("slidecontainer")[0].style.width = "300px"
      document.getElementsByClassName("links")[0].style.display = "flex"
      document.getElementsByClassName("menu")[0].style.display = "flex"
      document.getElementsByClassName("menu")[0].style.width = "300px"
      document.getElementById("pres").style.left = "460px";
      document.getElementById("pres").style.top = "135px";
    }

    if (document.getElementsByClassName("slidecontainer")[0].style.width == "180px" ) {
      document.getElementsByClassName("slidecontainer")[0].style.width = "300px"
      document.getElementsByClassName("links")[0].style.display = "none"
      document.getElementsByClassName("menu")[0].style.display = "flex"
      document.getElementsByClassName("menu")[0].style.width = "300px"
      document.getElementById("pres").style.left = "30px";
      document.getElementById("pres").style.top = "200px";
    }
  }

  const reduceClick = () => {
    if (document.getElementsByClassName("presentation")[0].style.width = "200px" ) {
      document.getElementsByClassName("presentation")[0].style.width = "50px"
      document.getElementsByClassName("presentation")[0].style.height = "50px"
      document.getElementsByClassName("slidecontainer")[0].style.width = "50px"
      document.getElementsByClassName("links")[0].style.display = "none"
      document.getElementsByClassName("menu")[0].style.display = "none"
    }
    document.getElementById("pres").style.left = "310px";
    document.getElementById("pres").style.top = "6px";
  }
 

  return (
    <div className='environment'>
      <Topbar />
      <Ide /> 
      
      <div className='presentation' id='pres'>
        <div className='menu'>
        <div className='buttons'>
        <button id='mobileminimize' onClick={mobilehandleClick}></button>
        <button id='minimize' onClick={handleClick}></button>
        <button id='min'></button>
        <button id='mobilemin' onClick={reduceClick}></button>
        <button id='maximize' onClick={altClick}></button>        
        <button id='mobilemaximize' onClick={mobilealtClick}></button>        
        </div>
        <div className='links'>     
          <a href='#slide1'><p></p></a>
          <a href='#slide2'><p></p></a>
          <a href='#slide3'><p></p></a>
          <a href='#slide4'><p></p></a>
          <a href='#slide5'><p></p></a>
          <a href='#slide6'><p></p></a>
          <a href='#slide7'><p></p></a>
          <a href='#slide8'><p></p></a>
        </div>
        </div>

        <div className='slidecontainer' onClick={mobileClick}>
        <div className='slide' id='slide1'><img src= 'https://drive.google.com/uc?id=1a0f0wuuRY-1SxuagnPlccDPDbD74-0sE' /></div>
        <div className='slide' id='slide2'><img src= 'https://drive.google.com/uc?id=1p5B8D2GrKv-cszulgfsPaRFGj9ZdfPh2' /></div>
        <div className='slide' id='slide3'><img src= 'https://drive.google.com/uc?id=1WesUaiBqcFZVI9mTxKVohdjHiGdX0U9H' /></div>
        <div className='slide' id='slide4'><img src= 'https://drive.google.com/uc?id=1wzZb87IALcGGnO_Y0wc9rewKrhHwMlXh' /></div>
        <div className='slide' id='slide5'><img src= 'https://drive.google.com/uc?id=1_6hDJicw036ujfz4zXaRo6T3COQNQIpt' /></div>
        <div className='slide' id='slide6'><img src= 'https://drive.google.com/uc?id=1d-rkH2SPhvADyKXDp1nNX2YlypYufJJO' /></div>
        <div className='slide' id='slide7'><img src= 'https://drive.google.com/uc?id=1sQuxRfnMContXWWgI9XxV_k3BW8Qtpxv' /></div>
        <div className='slide' id='slide8'><img src= 'https://drive.google.com/uc?id=1OKVE_hSttcKmCioEUKms7RT-vo6s4QeA' /></div>
        </div> 

      </div>
    </div>
  )
}
